'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _messages = require('../messages');

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var data = {
  yesterday: {
    from: (0, _moment2.default)().subtract(1, 'day').startOf('day').toDate(),
    to: (0, _moment2.default)().subtract(1, 'day').endOf('day').toDate()
  },
  week: {
    from: (0, _moment2.default)().subtract(1, 'week').startOf('day').toDate(),
    to: (0, _moment2.default)().subtract(1, 'day').endOf('day').toDate()
  },
  x2week: {
    from: (0, _moment2.default)().subtract(2, 'week').startOf('day').toDate(),
    to: (0, _moment2.default)().subtract(1, 'day').endOf('day').toDate()
  },
  month: {
    from: (0, _moment2.default)().subtract(1, 'month').startOf('day').toDate(),
    to: (0, _moment2.default)().subtract(1, 'day').endOf('day').toDate()
  }
};

exports.default = function (intl) {
  return Object.keys(data).map(function (key) {
    return _extends({}, data[key], {
      label: intl.formatMessage(_messages2.default[key])
    });
  });
};